import React, { useEffect, useState } from "react";
import { Flex, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom"

import { list, addeditdata, addeditVariantdata } from '../../../../controllers/V1/products/productController'

import LoadingEffect from "../../../../components/Loading/LoadingEffect";
import ProductUploadImage from "../UploadImge";
import "../product.css";

const AddEditVariantData  = () => {
  const location = useLocation();
  const state = location.state;
  const navigate = useNavigate();
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditData] = useState(state || []);
  const [ALLLISTDATA, setListData] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState(ADDEDITDATA?.product?._id??"");
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenUpload, setIsOpenUpload] = useState(false);
  const [childData, setChildData] = useState('');
  const handleUploadImage = () => setIsOpenUpload(!isOpenUpload);

  const handleChildData = (data) => {
    setChildData(data);
    if(data?._id){
      setAddEditData((prevState) => ({
        ...prevState,
        image: data?.url || '',
      }));
      
    }

  };
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: ""
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
        } else {
          setListData([]);
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End


  /*********************************************************
   *  This function is use to handle input change
   *********************************************************/
  const handleChange = (e) => {
    if(e.target.name==='product')
{
    setSelectedProductId(e.target.value);

}    setAddEditData((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };
  

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const form = new FormData(event.target);
      const params = {
        editId :form.get('edit_id')||ADDEDITDATA?._id  ,
        qty: form.get("qty"),
        unit: form.get("unit"),
        price: form.get("price"),
        product:selectedProductId
      };
      const isValidate = await validateFormData(params);

      if (isValidate === true) {
        const res = await addeditVariantdata(params);
        if (res.status === true) {
          notification.open({
            message: "Success.",
            description: `Data successfully added/updated.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/product/variants/list");
        } else {
          notification.open({
            message: "Error.",
            description: `${res.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Validation Error.",
          description: `Please check the form and try again.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      console.log("Error during submission:", error);
    }
  };

  /*********************************************************
   *  This function is used to validate form data before submit
   *********************************************************/
  const validateFormData = (formData) => {
    try {
      const { unit, qty, price,product } = formData;
      let isValid = true;
  
      if (!unit || unit.trim() === "") {
        setError((prevError) => ({ ...prevError, unit: "Unit is required." }));
        isValid = false;
      }
  
      if (!qty || qty.trim() === "") {
        setError((prevError) => ({ ...prevError, qty: "Qty is required." }));
        isValid = false;
      }
  
      if (!price || price.trim() === "") {
        setError((prevError) => ({ ...prevError, price: "price is required." }));
        isValid = false;
      }
      if (!product || product.trim() === "") {
        setError((prevError) => ({ ...prevError, product: "Product is required." }));
        isValid = false;
      }
  
      return isValid;
    } catch (error) {
      console.log("Validation error:", error);
      return false;
    }
  };
  useEffect(() => {
    document.title = `Orbit Kuwait || ${ADDEDITDATA?._id ? "Edit" : "Add"
      } Variant`;
      getList()
  }, []);

  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <React.Fragment>
            <h5 className="inventory_edit_page_heading"> {ADDEDITDATA?._id ? `Edit` : `Add`} variant </h5>
          </React.Fragment>
          <Link to={"/product/variants/list"}>
            <React.Fragment>
              <button type="button" className="btn btn-secondary"> <ArrowLeftOutlined /> Back </button>
            </React.Fragment>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
            <form method="post" className="inventory_form_main_contnet" onSubmit={handleSubmit}>
    <div className="row">

    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                      <label for="product" className="all_lable_for_vendor_dashbaord" > Select product : </label>
                      <select
  name="product"
  id="product"
  onChange={handleChange}
  value={selectedProductId}
  className="form-control categories_select_tg_enter_product"
>
<option>Select product</option>
  {ALLLISTDATA &&
    ALLLISTDATA.map((product, index) => (

      <option key={product._id || index} value={product._id}>
        {product.name}
      </option>
    ))}
</select>
{error.product && <p style={{ color: "red" }}>{error.product}</p>}
                    </div>
      <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
        <label htmlFor="unit" className="all_section_for_label_main_class">
          <span style={{ color: "red" }}>*</span>Unit:
        </label>
        <input
          title="Enter Unit."
          placeholder="Enter Unit."
          type="text"
          name="unit"
          className="form-control store_input_field"
          id="unit"
          value={ADDEDITDATA?.unit || ""}
          onChange={handleChange}
        />
        {error.unit && <p style={{ color: "red" }}>{error.unit}</p>}
      </div>

      <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
        <label htmlFor="description" className="all_section_for_label_main_class">
          <span style={{ color: "red" }}>*</span>Qty:
        </label>
        <input
          title="Enter Qty."
          placeholder="Enter Qty."
          type="number"
          name="qty"
          className="form-control store_input_field"
          id="qty"
          value={ADDEDITDATA?.qty || ""}
          onChange={handleChange}
        />
        {error.qty && <p style={{ color: "red" }}>{error.qty}</p>}
      </div>
      <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
        <label htmlFor="price" className="all_section_for_label_main_class">
          <span style={{ color: "red" }}>*</span>Price:
        </label>
        <input
          title="Enter Price."
          placeholder="Enter Price."
          type="number"
          name="price"
          className="form-control store_input_field"
          id="price"
          value={ADDEDITDATA?.price || ""}
          onChange={handleChange}
        />
        {error.price && <p style={{ color: "red" }}>{error.price}</p>}
      </div>


      <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center mt-4">
        <div className="verndor_dashboard_add_edit_button">
          <button type="submit" className="btn btn-primary inventory_save_button">
            Save
          </button>
        </div>
      </div>
    </div>
  </form>

            </div>
          </div>
        </div>
      </div>
      <ProductUploadImage openUpload={isOpenUpload} toggleUploadOpen={handleUploadImage} onSendData={handleChildData}/>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default AddEditVariantData;
